import {toast} from "react-toastify";
import _ from "lodash";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import React from "react";
import {toastError, toastSuccess} from "../../../../utils/toast";
import {makeApiCallDeleteWithData, makeApiCallPost} from "../../../../Api/makeApiCall";
import {getUserEmail} from "../../../../auth/accessTokenValidator";


const updateConfig = async (configEndpoint, trigger, isRemove) => {

    const salesEndDate = trigger.date
    const storeIds = trigger.storeIds
    const retailerId = Number(trigger.retailerId)
    const user = getUserEmail()

    const apiUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/storeSalesEndDateConfig/${configEndpoint}`
    const apiData = {retailerId, storeIds, salesEndDate, user}


    const apiReturn = isRemove ?
        (await makeApiCallDeleteWithData(apiUrl, [apiData])) :
        (await makeApiCallPost(apiUrl, apiData))

    if(isRemove === false && configEndpoint === 'storeStart' && trigger.storeStop) {
        const secondaryConfigEndpoint = 'storeStop'
        const secondaryApiUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/storeSalesEndDateConfig/${secondaryConfigEndpoint}`
        await makeApiCallDeleteWithData(secondaryApiUrl, [apiData])
    }

    if(isRemove === false && configEndpoint === 'storeStop' && trigger.storeStart) {
        const secondaryConfigEndpoint = 'storeStart'
        const secondaryApiUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/storeSalesEndDateConfig/${secondaryConfigEndpoint}`
        await makeApiCallDeleteWithData(secondaryApiUrl, [apiData])
    }

    const addOrRemoveText = isRemove ? "removed" : "added"
    if (!apiReturn?.apiError) {
        toastSuccess(toast, `Successfully ${addOrRemoveText} salesEndDate ${salesEndDate} for ${storeIds.length} storeId(s) to ${configEndpoint}`)
        trigger.setTimestamp(Date.now())
    } else {
        toastError(toast, `ERROR: salesEndDate ${salesEndDate} for ${storeIds.length} storeId(s) to ${configEndpoint} was not ${addOrRemoveText}`)
    }
}

const updateStoreClosureConfig = async (configEndpoint, trigger, isRemove) => {
    const storeId = trigger.storeIds[0]
    if (isRemove) {
        window.open(`/storeClosures?storeId=${storeId}`, '_blank')
        return
    }
    const retailerId = Number(trigger.retailerId)
    const apiUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/storeClosures?retailerId=${retailerId}&single_row_action=update`
    const cellDate = trigger.date
    const apiData = {startDate: cellDate, storeId: storeId, endDate: null, index: null}
    const postReturn = await makeApiCallPost(apiUrl, apiData)
    if (!postReturn?.apiError) {
        toastSuccess(toast, `Successfully added store closure information for ${storeId} to ${configEndpoint}`);
        trigger.setTimestamp(Date.now())
    } else {
        toastError(toast, `Error with adding store closure information for ${storeId} to ${configEndpoint}`);
    }
}

const MENU_ITEMS_TABLE_BODY = [
    {config: 'storeStart', displayName: 'Measures Start', endpointFunction: updateConfig},
    {config: 'storeStop', displayName: 'Measures Stop', endpointFunction: updateConfig},
    {config: 'alwaysFill', displayName: 'Always Fill', endpointFunction: updateConfig},
    {config: 'doNotFill', displayName: 'Do Not Fill', endpointFunction: updateConfig},
];

const MENU_HEADER_ITEMS = [
    {
        config: 'storeStart',
        displayName: <span data-testid={'header-measures-start-on'}>Measures Start <b>ON</b></span>,
        isRemove: false,
        endpointFunction: updateConfig
    },
    {
        config: 'storeStart',
        displayName: <span data-testid={'header-measures-start-off'}>Measures Start <b>OFF</b></span>,
        isRemove: true,
        endpointFunction: updateConfig
    },
    {
        config: 'storeStop',
        displayName: <span data-testid={'header-measures-stop-on'}>Measures Stop <b>ON</b></span>,
        isRemove: false,
        endpointFunction: updateConfig
    },
    {
        config: 'storeStop',
        displayName: <span data-testid={'header-measures-stop-off'}>Measures Stop <b>OFF</b></span>,
        isRemove: true,
        endpointFunction: updateConfig
    },
    {
        config: 'alwaysFill',
        displayName: <span data-testid={'header-always-fill-on'}>Always Fill <b>ON</b></span>,
        isRemove: false,
        endpointFunction: updateConfig
    },
    {
        config: 'alwaysFill',
        displayName: <span data-testid={'header-always-fill-off'}>Always Fill <b>OFF</b></span>,
        isRemove: true,
        endpointFunction: updateConfig
    },
    {
        config: 'doNotFill',
        displayName: <span data-testid={'header-do-not-fill-on'}>Do Not Fill <b>ON</b></span>,
        isRemove: false,
        endpointFunction: updateConfig
    },
    {
        config: 'doNotFill',
        displayName: <span data-testid={'header-do-not-fill-off'}>Do Not Fill <b>OFF</b></span>,
        isRemove: true,
        endpointFunction: updateConfig
    },
];

const getStoreClosureMenuItem = (trigger) => {
    const hasStartDate = trigger.storeClosures?.some(x => !_.isNil(x.startDate)) || false;

    return hasStartDate ? {
        config: 'storeClosure',
        displayName: 'Closure Stop',
        isRemove: true,
        endpointFunction: updateStoreClosureConfig
    } : {
        config: 'storeClosure',
        displayName: 'Closure Start',
        isRemove: false,
        endpointFunction: updateStoreClosureConfig
    };
};

const getMenuItems = (baseMenuItems, trigger) => {
    if (!trigger) {
        return [];
    }

    const menuItems = trigger.header ? baseMenuItems : [...baseMenuItems, getStoreClosureMenuItem(trigger)];

    return menuItems.map(config => {
        const triggerHasDataForConfig = trigger[config.config];
        const isRemove = config.isRemove || triggerHasDataForConfig || false;
        const className = `${triggerHasDataForConfig ? '' : 'hollow '}${config.config}${trigger.header ? '-header' : ''}${isRemove ? '-remove' : '-add'}-menu-item button secondary`
        return <DropdownMenu.Item
            key={`${config.config}-${config.isRemove}`}
            className={className}
            onSelect={() => config.endpointFunction(config.config, trigger, config.isRemove || isRemove)}>
            {config.displayName}
        </DropdownMenu.Item>
    });
};

export const ConfigUpdateContextMenu = ({trigger}) => {
    const isHeader = trigger && trigger.header === true;

    return (
        <DropdownMenu.Portal>
            <DropdownMenu.Content className={'store-totals-context-menu'} align={'center'} side={'bottom'}>
                {getMenuItems(isHeader ? MENU_HEADER_ITEMS : MENU_ITEMS_TABLE_BODY, trigger)}
            </DropdownMenu.Content>
        </DropdownMenu.Portal>
    );
};
